<script>
    import {links} from "svelte-routing";
    import Service from "../utils/Service";
    import MobileHeader from "./MobileHeader.svelte";

    export let config;

    const service = new Service(config.model_root);

    let isMenuOpen = false; // Für das mobile Menü

    let menuItems = loadMenuItems(0);

    const user_defined_config = service.loadSystemConfig();

    function loadMenuItems(footer) {
        return fetch(config.model_root + 'shared/menu/load_menu_items.php?footer=' + footer, {
            method: "GET"
        })
            .then(response => response.json());
    }

    function getNumberOfMenuItemsByParentId(data, parentId) {
        const filteredItems = data.filter(item => item.mparent == parentId);
        return filteredItems.length;
    }

    function toggleMenu() {
        isMenuOpen = !isMenuOpen;
    }
</script>

<div class="header mb-5" use:links>
    <div class="white-background"></div>
    <div class="container">
        <div class="logo-container">
            <a href="/"><img src="../images/LOGO.JPG" alt="Logo" class="logo img-fluid"/></a>
        </div>
        <div class="text-container">
            <h2 class="main-title">Heimat und Genuss</h2>
            <h3 class="sub-title">Dorfladen Gungolding</h3>
            {#await menuItems}
            {:then data}
                <nav class="navbar {isMenuOpen ? 'open' : ''}">
                    <ul class="nav-list">
                        {#each data as item}
                            {#if item.mparent === null}
                                <li class="nav-item">
                                    <a class="nav-link" href="/site/{item.urlname}-m-{item.mid}">{@html item.mname}</a>
                                    {#if getNumberOfMenuItemsByParentId(data, item.mid) > 0}
                                        <ul class="sub-nav-list">
                                            {#each data as subitem}
                                                {#if subitem.mparent === item.mid}
                                                    <li class="sub-nav-item">
                                                        <a class="sub-nav-link"
                                                           href="/site/{subitem.urlname}-m-{subitem.mid}">{@html subitem.mname}</a>
                                                    </li>
                                                {/if}
                                            {/each}
                                        </ul>
                                    {/if}
                                </li>
                            {/if}
                        {/each}
                    </ul>
                </nav>
            {:catch error}
                <p style="color: red">{error.message}</p>
            {/await}
        </div>
        <div class="info-box">
            {#await user_defined_config}
            {:then configdata}
                <p>
                    <strong><i class="far fa-clock"></i> Öffnungszeiten:</strong>
                    <br>
                    <span style="white-space: pre-line">{configdata.OPENING_HOURS}</span>
                </p>
                <p>
                    <strong><i class="fas fa-home"></i> Adresse:</strong>
                    <br>
                    <span style="white-space: pre-line">{configdata.ADDRESS}</span>
                </p>
            {/await}
        </div>
    </div>
    <MobileHeader {isMenuOpen} {toggleMenu} {user_defined_config} {menuItems} {getNumberOfMenuItemsByParentId} />
</div>

<style>
    .info-box, .text-container, .info-box-mobile {
        height: 220px;
        position: relative; /* Ermöglicht die Nutzung von ::before */
        border-radius: 12px; /* Abgerundete Ecken */
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        padding: 12px 25px; /* Innenabstand */
        /*box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15); !* Tieferer Schatten *!*/
        font-size: 1rem; /* Schriftgröße */
        color: #333; /* Textfarbe */
        text-align: center; /* Zentrierter Text */
        /* Abstand und Zentrierung */
        margin: 10px 0px 20px auto;
        width: fit-content; /* Passt die Breite an den Inhalt an */
        z-index: 10; /* Über anderen Elementen */
    }

    .info-box {
        /*background-color: #f8f9fa; !* Hellgrauer Hintergrund *!*/
        /*border: solid 1px #32502e;*/
    }

    .info-box::before, .text-container::before {
        content: '';
        position: absolute;
        top: -3px; /* Oberhalb der Box */
        left: 0;
        width: 100%; /* Gleiche Breite wie die Box */
        height: 3px; /* Höhe der geschwungenen Fläche */
        background: #32502e; /* Gleiche Farbe wie die Box */
        border-top-left-radius: 50%; /* Halbkreis für den "Schäl"-Effekt */
        border-top-right-radius: 50%; /* Halbkreis für den "Schäl"-Effekt */
        box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1); /* Schatteneffekt für Tiefe */
        z-index: -1; /* Hinter der Box */
    }

    .text-container {
        padding-top: 25px;
    }


    .header {
        position: relative;
        height: 180px;
        display: flex;
        align-items: center;
        overflow: visible;
        padding-bottom: 0px;
    }

    .white-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: white;
        border-radius: 0 0 15% 15%;
        z-index: 0;
    }

    @media (min-width: 1200px) {
        .header {
            height: 300px;
            padding-bottom: 40px;
        }
        .white-background {
            border-radius: 0 0 50% 50%;
        }
    }

    .container {
        position: relative;
        text-align: center;
        padding-left: 40px;
        padding-right: 40px;
        z-index: 1;
    }

    .logo-container {
        margin-right: 0px;
        margin-top: 0px;
    }

    .logo {
        width: 300px;
        height: auto;
    }

    @media (min-width: 1200px) {
        .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .logo-container {
            margin-right: 30px;
            margin-top: -35px;
        }
        .logo {
            width: 400px;
        }
    }

    .main-title {
        font-size: 2.5rem;
        margin: 0;
        letter-spacing: 1px;
    }

    .sub-title {
        font-size: 1.8rem;
        margin: 0;
        letter-spacing: 0.5px;
        margin-bottom: 15px;
    }

    /* Navigation Styles */
    .nav-item {
        font-size: 1.2rem;
        position: relative; /* Ermöglicht, dass das Dropdown relativ zum Menu-Element positioniert wird */
    }

    .nav-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        gap: 15px;
        align-items: center;
        position: relative; /* Für die Positionierung des Dropdowns */
    }

    .nav-link {
        font-family: 'Dancing Script', cursive; /* Verspielte, handschriftliche Schrift */
        font-size: 1.30rem; /* Etwas größere Schrift */
        text-decoration: none;
        padding: 8px 14px;
        color: #4a3f35; /* Dunkler Braunton passend zum Logo */
        background: rgba(255, 255, 255, 0.85); /* Heller, warmer Hintergrund */
        border: 2px solid #4a3f35; /* Dunkle Kontur */
        border-radius: 8px;
        box-shadow: 3px 3px 0px #4a3f35; /* Gezeichneter Schatten */
        transition: all 0.3s ease-in-out;
        position: relative;
        overflow: hidden;
    }

    .nav-link:hover {
        background: #586a58; /* Grünlicher Ton passend zum Logo */
        color: #fff; /* Weiße Schrift beim Hover */
        box-shadow: 5px 5px 0px #4a3f35; /* Verstärkter Schatten */
        transform: translate(-2px, -2px);
    }

    .nav-link:active {
        box-shadow: 1px 1px 0px #4a3f35;
        transform: translate(2px, 2px);
    }


    .sub-nav-list {
        min-width: 200px;
        display: none; /* Standardmäßig ausgeblendet */
        position: absolute;
        top: 100%;
        left: 0;
        background: rgba(255, 255, 255, 0.85); /* Gleicher heller Hintergrund */
        border: 2px solid #4a3f35; /* Dunkle Kontur wie bei Hauptmenü */
        border-radius: 8px; /* Abgerundete Ecken */
        box-shadow: 3px 3px 0px #4a3f35; /* Gezeichneter Schatten */
        z-index: 1000;
        padding: 10px 0;
        list-style: none;
    }

    .sub-nav-item {
        margin: 0; /* Abstand zurücksetzen */
    }

    .sub-nav-link {
        display: block;
        padding: 10px 20px;
        /*font-family: 'Dancing Script', cursive; !* Einheitliche Schrift *!*/
        font-size: 1rem;
        text-decoration: none;
        color: #4a3f35; /* Dunkler Braunton */
        transition: all 0.3s ease-in-out;
        position: relative;
    }

    .sub-nav-link:hover {
        background: #eaeaea; /* Leichte Hintergrundänderung beim Hover */
        color: #4a3f35; /* Beibehaltung der Schriftfarbe für einheitlichen Look */
    }

    .nav-item:hover .sub-nav-list {
        display: block;
        animation: fadeIn 0.1s; /* Fade-In-Effekt */
    }

    /* Optional: Fade-In-Effekt */
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @media (max-width: 1200px) {
        .container {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .text-container, .info-box {
            display: none;
        }
    }

</style>
